import AboutContainer from './about_container';

const About = AboutContainer;
export default About;
